import type {CourseApiModel} from '../../../api/course';
import type {Nullable} from '../../../utils/utility-types';

import {currentUserStore} from '../../../api/user';
import {envManager} from '../../../utils/env';
import {isCourseCorporate} from './isCourseCorporate';

export const isCourseDeletable = (course?: Nullable<CourseApiModel>) => {
  if (!course || envManager.isB2b || isCourseCorporate(course)) {
    return false;
  }

  const amountOfUsersRelatedToCourse = Object.values(
    course.counters.memberships,
  ).reduce((acc, val) => acc + val, 0);
  const isCoursePlannedAndEmpty =
    course.status === 'planned' &&
    amountOfUsersRelatedToCourse === 0 &&
    course.counters.memberships.proposed === 0;

  const isUserMainCoach = course.user_id === currentUserStore.user?._id;

  return (
    isUserMainCoach && (course.status === 'archived' || isCoursePlannedAndEmpty)
  );
};
